import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import FIGHT_MODE from "./FIGHT_MODE";
import {FightFormPage} from "../fight-form/fight-form";
import {RoomProvider} from "../../providers/room/room";
import FIGHT_STATUS from "./FIGHT_STATUS";
import CONFIG_PAGES from "../CONFIG_PAGES";

/**
 * Generated class for the FightPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-fight',
    templateUrl: 'fight.html',
    providers: [RoomProvider]
})
export class FightPage {

    public modes = FIGHT_MODE;
    public statuses = FIGHT_STATUS;
    public configPages = CONFIG_PAGES;

    public intervalList = null;

    params: any = {page: 0, ppp: 1000, room_type: FIGHT_MODE.SINGLE};

    filterMode = FIGHT_MODE.SINGLE;

    public fightFormPage = FightFormPage;

    rooms = [];

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public roomProvider: RoomProvider,
                public loadingCtrl: LoadingController) {
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad FightPage');
    }

    ionViewDidEnter() {
        console.log('ionViewDidEnter FightFormPage');
        this.loadList();

        this.intervalList = setInterval(() => {
            this.loadList(false);
        }, 5000);
    }

    ionViewWillLeave() {
        clearInterval(this.intervalList);
    }

    changeMode(mode) {
        this.params.room_type = mode;
        this.loadList();
    }

    loadList(isLoading = true) {

        let loader = null;

        if (isLoading) {
            loader = this.loadingCtrl.create({
                content: "Please wait..."
            });
            loader.present();
        }

        this.roomProvider.list(this.params).subscribe((resp: any) => {
            this.rooms = resp.data || [];

            if (isLoading) {
                loader.dismiss();
            }
        }, err => {
            if (isLoading) {
                loader.dismiss();
            }
        });
    }

    accessRoom(room: any) {
        const loader = this.loadingCtrl.create({
            content: "Please wait...",
            duration: 3000
        });
        loader.present();

        this.roomProvider.connect(room.id).subscribe((resp: any) => {
            loader.dismiss();

            if (!resp.status || resp.data.status !== 'new') {
                return;
            }

            this.navCtrl.push(this.configPages[room.board_name], {room: room});
        }, err => {
            loader.dismiss();
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/fight/fight.ts